import { z } from "zod";

export const ServiceAppointmentRequestSchema = z.object({
  BusinessUnitId: z.string().uuid(),
  ServiceId: z.string().uuid(),
  ProductId: z.string().uuid(),
  EngineerId: z.string().uuid(),
  Year: z.number(),
  Month: z.number(),
  Day: z.number(),
  StartHours: z.number(),
  StartMinutes: z.number(),
  DurationMinutes: z.number(),
  UserId: z.string().uuid(),
  ContactPhone: z.string(),
  ContactEmail: z.string().email(),
  Notes: z.string().optional(),
  Subject: z.string(),
  ServiceName: z.string(),
  ProductName: z.string(),
});

export type ServiceAppointmentRequestType = z.infer<
  typeof ServiceAppointmentRequestSchema
>;
